import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-avviso-ie',
  templateUrl: './avviso-ie.component.html',
  styleUrls: ['./avviso-ie.component.scss']
})
export class AvvisoIeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/avviso-ie/avviso-ie.component.ts